import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { DialogHelperService } from 'app/services/dialog-helper.service';
import { AssetDataTable } from 'app/models/asset-data-table';
import {IFile} from 'app/models/file'
@Component({
  selector: 'app-asset-data-table',
  templateUrl: './asset-data-table.component.html',
  styleUrls: ['./asset-data-table.component.scss'],
  providers: [DialogHelperService]
})
export class AssetDataTableComponent implements OnInit {

  @Input() data: AssetDataTable;
  @Input() source: string;
  @Input() showRowNumber: boolean;
  @Input() showView: boolean;
  @Input() allowEdit: boolean;
  @Input() allowDelete: boolean;
  @Input() allowDrop: boolean;
  @Input() allowItemOrder: boolean;
  @Input() showContent: boolean;

  @Output() open: EventEmitter<boolean> = new EventEmitter();
  @Output() view: EventEmitter<AssetDataTable> = new EventEmitter();
  @Output() edit: EventEmitter<AssetDataTable> = new EventEmitter();
  @Output() delete: EventEmitter<AssetDataTable> = new EventEmitter();
  @Output() save: EventEmitter<AssetDataTable> = new EventEmitter();

  constructor(private dialogHelper: DialogHelperService) { }

  ngOnInit() { }

  toggleContent() {
    this.showContent = !this.showContent;
    this.open.emit(this.showContent);
  }

  onView(event) {
    event.stopPropagation();
    this.view.emit(this.data);
  }

  onEdit(event) {
    event.stopPropagation();
    this.edit.emit(this.data);
  }

  onDelete(event) {
    event.stopPropagation();
    this.dialogHelper.showConfirm(
      'Are you sure you want to delete',
      this.data.name,
      'DELETE ' + (!!this.source ? this.source.toUpperCase() : 'FILE'),
      () => this.delete.emit(this.data)
    );
  }

  onOrderFiles(idx, event) {
    const item = event.dragData;
    this.data.files = this.data.files.filter((f) => f.id !== item.id);
    this.data.files.splice(idx, 0, item);
    if (this.save) {
      this.save.emit(this.data);
    }
  }

  onRemoveFile(event) {
    this.data.files = this.data.files.filter((file) => file.id !== event.id);
    if (this.save) {
      this.save.emit(this.data);
    }
  }

  onDrop(event) {
    if (!this.data.files.some((file) => file.id === event.dragData.id)) {
        //optimising the soved data to the minimum (5 against 10)
        console.log("event",  event.dragData)
        const newFile:IFile={
          id:event.dragData.id,
          source:event.dragData.source,
          createdTime:event.dragData.createdTime,
          name:event.dragData.displayName.toLowerCase(),
          displayName:event.dragData.displayName,
          contentType:event.dragData.contentType,
          contentId: event.dragData.contentId,
          fileUrl: event.dragData.fileUrl
        }
      this.data.files.push(newFile);
      if (this.save) {
        this.save.emit(this.data);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/asset-data-table/asset-data-table.component.ts